import type { ModuleStorage } from "app/pages/sales-intelligence/services/storage/types";
import createEducationBarStorage from "app/pages/sales-intelligence/sub-modules/education-bar/services/storage/factory";

export default function createManagementIntegrationStorage(storageProvider: ModuleStorage) {
    return createEducationBarStorage(storageProvider);
}
